import { Input } from './input'

const variants = {
  outline: Input.variants.outline.field,
}

const sizes = {
  sm: Input.sizes.sm.field ?? {},
  md: Input.sizes.md.field ?? {},
}

const defaultProps = {
  size: 'md',
  variant: 'outline',
}

export const Textarea = {
  baseStyles: {
    ...Input.baseStyle.field,
  },
  sizes,
  variants,
  defaultProps,
}
